@let form = this.form();
<div class="container-xl">
    <div class="filter-bar">
        <div [formGroup]="form" class="row">
            <div class="col">
                <div class="d-flex gap-2">
                    <div class="d-flex align-self-center">
                        <button
                            (click)="changeSelectedYear('decrement')"
                            [class.disabled]="form?.controls.selectedYear.value === 2015 || form?.controls.selectedYear.value === null"
                            class="btn btn-secondary">
                            <i class="material-icons">remove</i>
                        </button>
                    </div>
                    <div class="flex-fill">
                        <ng-select
                            [clearable]="false"
                            [items]="years()"
                            [searchable]="true"
                            bindLabel="name"
                            bindValue="value"
                            placeholder="Jaar"
                            formControlName="selectedYear">
                        </ng-select>
                    </div>
                    <div class="d-flex align-self-center">
                        <button
                            (click)="changeSelectedYear('increment')"
                            [class.disabled]="form?.controls.selectedYear.value === currentYear"
                            class="btn btn-secondary">
                            <i class="material-icons">add</i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex gap-2">
                    <div class="d-flex align-self-center">
                        <button
                            (click)="changeSelectedWeek('decrement')"
                            [class.disabled]="form?.controls.selectedWeek.value === 1 || form?.controls.selectedWeek.value === null"
                            class="btn btn-secondary">
                            <i class="material-icons">remove</i>
                        </button>
                    </div>
                    <div class="flex-fill">
                        <ng-select
                            [clearable]="false"
                            [items]="weeks()"
                            [searchable]="true"
                            bindLabel="name"
                            bindValue="value"
                            placeholder="Week"
                            formControlName="selectedWeek">
                        </ng-select>
                    </div>
                    <div class="d-flex align-self-center">
                        <button (click)="changeSelectedWeek('increment')" [class.disabled]="form?.controls.selectedWeek.value === 53" class="btn btn-secondary">
                            <i class="material-icons">add</i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="d-flex gap-2">
                    <div class="d-flex align-self-center">
                        <button
                            (click)="changeSelectedUser('decrement')"
                            [class.disabled]="currentUserIndex <= 0"
                            class="btn btn-secondary">
                            <i class="material-icons">arrow_downward</i>
                        </button>
                    </div>
                    <div class="flex-fill">
                        <ng-select
                            [clearable]="false"
                            [items]="users()"
                            [searchable]="true"
                            bindLabel="name"
                            bindValue="id"
                            placeholder="Medewerker"
                            formControlName="selectedUser">
                        </ng-select>
                    </div>
                    <div class="d-flex align-self-center">
                        <button
                            (click)="changeSelectedUser('increment')"
                            [class.disabled]="currentUserIndex >= users().length - 1"
                            class="btn btn-secondary">
                            <i class="material-icons">arrow_upward</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="d-flex flex-nowrap overflow-x-auto gap-4">
        @for (date of weekDates(); track $index) {
            @let regDay = (registrationsByDay() | findByDate: date);
            @let dayPrs = (pullRequestsByDay() | findByDate: date)?.prs ?? [];
            <div class="col registration-week-col">
                <div class="registration-area">
                    @if (regDay) {
                        <registrations-by-day
                            (approved)="fetchWeek()"
                            [companies]="companies()"
                            [contextMenuFn]="openContextMenu.bind(this)"
                            [registrationDay]="regDay"
                            [showCompany]="!!form?.controls.selectedCompany.value"
                            [showUser]="!!form?.controls.selectedUser.value">
                        </registrations-by-day>
                    } @else {
                        <div class="my-3 registration-placeholder">
                            <h4 class="first-letter-capital"><strong>{{date | date: 'EEEE d MMMM yyyy'}}</strong></h4>
                        </div>
                        <hr class="striped-spacing">
                    }
                </div>
                <div class="pr-list">
                    @for (pr of dayPrs; track pr.pullRequestId) {
                        <div class="border rounded p-2 mb-2">
                            <div class="fw-semibold">
                                <a [href]="'https://dev.azure.com/codalt/' + pr.project + '/_git/' + pr.repository + '/pullrequest/' + pr.pullRequestId"
                                   target="_blank">{{pr.title}}</a>
                            </div>
                            <div class="text-muted small">
                                {{pr.repository}} &raquo; {{pr.sourceRefName | azureBranchName}} &rarr; {{pr.targetRefName | azureBranchName}}
                            </div>
                            <div class="d-flex align-items-center gap-2 mt-1 flex-wrap">
                                <span
                                    [class.bg-secondary]="pr.status !== 'completed' && pr.status !== 'active'"
                                    [class.bg-success]="pr.status === 'completed'"
                                    [class.bg-warning]="pr.status === 'active'"
                                    class="badge">
                                    {{pr.status}}
                                </span>
                                <span class="text-muted small">{{pr.creationDate | date: 'EEEE d MMM yyyy HH:mm'}}</span>
                                @for (reviewer of pr.reviewers; track reviewer.id) {
                                    <img
                                        [class.approved]="reviewer.vote === 10"
                                        [class.rejected]="reviewer.vote === -10"
                                        [src]="reviewer.imageUrl"
                                        [title]="reviewer.displayName + (reviewer.vote === 10 ? ' ✓' : reviewer.vote === -10 ? ' ✗' : '')"
                                        alt="" class="rounded-circle reviewer-avatar" height="20" width="20">
                                }
                            </div>
                            @if (pr.workItems?.length) {
                                <div class="mt-1 work-items-list">
                                    @for (wi of pr.workItems; track wi.id) {
                                        <div class="text-muted small work-item-row">
                                            <span class="work-item-type">{{wi.workItemType}}</span>
                                            <span class="badge bg-light text-dark border">{{wi.state}}</span>
                                            #{{wi.id}} {{wi.title}}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>

<ng-template #taskContextMenu>
    <div class="context-menu-panel">
        @if (contextMenuTask()) {
            <div (click)="approveHour(contextMenuTask().id)" class="context-menu-cell">
                uur goedkeuren
            </div>
            <div (click)="disapproveHour(contextMenuTask().id)" class="context-menu-cell">
                uur afkeuren
            </div>
            <div (click)="changeRegistrationProject(contextMenuTask())" class="context-menu-cell">
                project aanpassen
            </div>
        } @else {
            <div class="context-menu-header text-muted">Uren niet gevonden</div>
        }
    </div>
</ng-template>
